export const productRequest = {
  productRequest: "Αίτημα Προϊόντος",
  myRequests: "Τα αιτήματά μου",
  createRequest: "Δημιουργία αιτήματος",
  request: "Αίτημα",
  requestDetails: "Λεπτομέρειες αιτήματος",
  requestProperties: "Ιδιότητες αιτήματος",
  requestCategories: "Κατηγορίες αιτήματος",
  createProductRequest: "Δημιουργία αιτήματος προϊόντος",
  deleteProductRequest: "Διαγραφή αιτήματος προϊόντος",
  areYouSureYouWantToDeleteThisProductRequest:
    "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το αίτημα προϊόντος;",
  thisActionCannotBeUndone: "Αυτή η ενέργεια δεν μπορεί να αναιρεθεί",
  productRequestDeletedSuccessfully:
    "Το αίτημα προϊόντος διαγράφηκε με επιτυχία",
  aiDsDtRequestUpdatedSuccessfully:
    "Το αίτημα AI-DS/DT ενημερώθηκε με επιτυχία",
  operationRequestUpdatedSuccessfully:
    "Το αίτημα λειτουργίας ενημερώθηκε με επιτυχία",
  operationRequestSavedSuccessfully:
    "Το αίτημα λειτουργίας αποθηκεύτηκε με επιτυχία",
  completed: "Ολοκληρώθηκε",
  rejected: "Απορρίφθηκε",
  inProgress: "Σε εξέλιξη",
  requested: "Ζητήθηκε",
  pending: "Σε αναμονή",
  working: "Σε εξέλιξη",
  currentStep: "Τρέχον Βήμα",
  productRequestStatus: "Κατάσταση αιτήματος προϊόντος",
  factoryOwnerRequirements: "Απαιτήσεις ιδιοκτήτη εργοστασίου",
  capabilities: "Δυνατότητες",
  addOperation: "Προσθήκη λειτουργίας",
  removeLastOperation: "Αφαίρεση τελευταίας λειτουργίας",
  addStep: "Προσθήκη βήματος",
  removeLastStep: "Αφαίρεση τελευταίου βήματος",
  unmetTaktPenalty: "Ποινή μη εκπλήρωσης takt",
  operationName: "Όνομα λειτουργίας",
  capability: "Δυνατότητα",
  serviceNotAvailable: "Η υπηρεσία δεν είναι διαθέσιμη",
  results: "Αποτελέσματα",
  plantLocation: "Τοποθεσία εργοστασίου",
  qualityProduction: "Παραγωγή ποιότητας",
  scrapRate: "Ποσοστό απορριμμάτων",
  spaceAvailabilityIndex: "Δείκτης διαθεσιμότητας χώρου",
  throughputRate: "Ρυθμός διέλευσης",
  downtimeCost: "Κόστος αδράνειας",
  energyConsumption: "Κατανάλωση ενέργειας",
  phaseType: "Τύπος διαδικασίας",
  procurement: "Προμήθεια",
  production: "Παραγωγή",
  requiredProperties: "Απαιτούμενες ιδιότητες",
  include: "Συμπερίληψη",
  viewProduct: "Προβολή προϊόντος",
  totalTimeOfRepairs: "Συνολικός Χρόνος Επισκευών",
  numberOfRepairs: "Αριθμός Επισκευών",
  availableOperatingTimePerPart: "Διαθέσιμος Χρόνος Λειτουργίας ανά Τμήμα",
  plannedProductionTimePerPart: "Προγραμματισμένος Χρόνος Παραγωγής ανά Τμήμα",
  plannedCycleTime: "Προγραμματισμένος Χρόνος Κύκλου",
  productionLeadTime: "Χρόνος Παράδοσης Παραγωγής",
  cycleTime: "Χρόνος Κύκλου",
  oee: "OEE (Συνολική Αποτελεσματικότητα Εξοπλισμού)",
  cpk: "CPK (Δείκτης Ικανότητας Διεργασίας)",
  ppk: "PPK (Δείκτης Απόδοσης Διεργασίας)",
  mttr: "MTTR (Μέσος Χρόνος Επισκευής)",
  mtbf: "MTBF (Μέσος Χρόνος Μεταξύ Αποτυχιών)",
  ppm: "PPM (Μέρη Ανά Εκατομμύριο)",
  dpmo: "DPMO (Ελαττώματα Ανά Εκατομμύριο Ευκαιρίες)",
  fpy: "FPY (Αρχική Απόδοση)",
  rty: "RTY (Συνολική Απόδοση Παραγωγής)",
  productionPhaseSupportRequest: "Αίτημα Υποστήριξης Φάσης Παραγωγής",
  maximumMTTR: "Μέγιστο MTTR",
  minimumMTBF: "Ελάχιστο MTBF",
  budget: "Προϋπολογισμός",
  operations: "Λειτουργίες",
  processDuration: "Διάρκεια Διαδικασίας",
  numberOfSteps: "Αριθμός Βημάτων",
  precedentOperations: "Προηγούμενες Λειτουργίες",
  steps: "Βήματα",
  stepName: "Όνομα Βήματος",
  stepDuration: "Διάρκεια Βήματος",
  stepsNo: "Αριθμός Βημάτων",
  step: "Βήμα",
  operation: "Λειτουργία",
  noIncumbentEquipment: "Δεν υπάρχει εξοπλισμός",
  group: "Ομάδα",
  groups: "Ομάδες",
  addGroup: "Προσθήκη ομάδας",
  existingLine: "Υπάρχουσα Γραμμή",
  processingRequest: "Το αίτημα υποβλήθηκε με επιτυχία",
  longRunningProcessDisclaimer:
    "Το αίτημά σας υποβλήθηκε με επιτυχία. Αυτή είναι μια διαδικασία μεγάλης διάρκειας που μπορεί να χρειαστεί κάποιο χρόνο για να ολοκληρωθεί. Τα αποτελέσματα θα εμφανιστούν σε αυτή τη σελίδα μόλις είναι έτοιμα. Θα ειδοποιηθείτε μόλις ολοκληρωθεί η διαδικασία.",
  backToRequests: "Επιστροφή στα αιτήματά μου",
  confirmChangeSelection:
    "Είστε σίγουροι ότι θέλετε να αλλάξετε την επιλογή; Οποιαδήποτε μη αποθηκευμένη πρόοδος θα χαθεί.",
};
